import {ApiBase} from "./ApiBase";

export class UserBehaviorTrackerApi {
    public static trackUserBehavior(pathAndTab: string) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ApiBase.processPost("/user-behavior-tracker", { pathAndTab }).catch(() => {});
    }
}